<template>
  <div class="details">
    <info-items :items="detailItems" :info="info">
      <div class="detail-item full-width">
        <div class="label">地区定位：</div>
        <div class="value">
          <div class="local-pos">
            <span class="local-label">定位 ：</span>
            <span class="position">{{ info.address }}</span>
          </div>
          <div class="local-pos">
            <span class="local-label">区域 ：</span>
            <span>{{ info.province + info.city + info.district }}</span>
          </div>
          <div class="local-pos">
            <span class="local-label">详细地址 ：</span>
            <span>{{ info.address }}</span>
          </div>
        </div>
      </div>
    </info-items>
  </div>
</template>

<script>
import InfoItems from "@/views/components/info-items";
export default {
  name: "detail-info",
  props: { info: Object },
  data() {
    return {
      detailItems: [
        { label: "客户名称", prop: "customerName" },
        { label: "客户级别", prop: "customerLevelName" },
        { label: "税号", prop: "taxNumber" },
        { label: "来源", prop: "formSourceName" },
        { label: "所属行业", prop: "industryClassName" },
        { label: "电话", prop: "tel" },
        { label: "邮箱", prop: "email" },
        { label: "传真", prop: "fax" },
        { label: "网址", prop: "url" },
        { label: "归属部门", prop: "chargeDeptName" },
        { label: "备注", prop: "remark" },
        { label: "下次跟进时间", prop: "nextLinkTime" },
      ],
    };
  },
  components: { InfoItems },
};
</script>

<style scoped lang="scss">
.details {
  padding-left: 70px;
  max-width: 1000px;
  .label{
    width: 120px;
  }
  .local-pos {
    line-height: 1.8;
    .local-label {
      display: inline-block;
      width: 80px;
      text-align: right;
    }
    .position {
      color: #006eff;
    }
  }
}
</style>
